<template>
  <v-container>
    <v-card class="nl-theme-background white--text">
      <EditProfileForm
        :first-name="profile.firstName || ''"
        :last-name="profile.lastName || ''"
        :birth-date="profile.birthDate || ''"
        :sex="profile.sex || ''"
        @submit="submit"
      />
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import EditProfileForm from '@/components/EditProfileForm.vue';

export default {
  name: 'CreateProfilePage',
  components: {
    EditProfileForm,
  },
  computed: mapState('profile', ['profile']),
  methods: {
    submit() {
      this.$router.push({
        name: 'createProfileConsent',
      });
    },
  },
};
</script>
